<template>
  <Toast ref="toastRef" />
  <LoadingOverlay ref="loadingOverlayRef" />
  <CookieBanner />
  <router-view />
</template>

<script setup>
import { onMounted, ref, nextTick } from 'vue'
import { useAuthStore } from '@/stores/authStore'
import { useCookieStore } from '@/stores/useCookieStore'
import { cookieService } from '@/services/cookieService'
import { setToastComponent } from '@/composables/useToast'
import { setLoadingOverlayComponent } from '@/composables/useLoadingOverlay'
import Toast from '@/components/Toast.vue'
import LoadingOverlay from '@/components/LoadingOverlay.vue'
import CookieBanner from '@/components/CookieBanner.vue'

const toastRef = ref(null)
const loadingOverlayRef = ref(null)

onMounted(async () => {
  await nextTick()
  const authStore = useAuthStore()
  authStore.initializeFromSessionStorage()

  if (authStore.isAuthenticated) {
    try {
      const { useCart } = await import('@/composables/useCart')
      const { fetchServerCart } = useCart()
      await fetchServerCart()
    } catch (err) {
      console.error('[APP] Error fetching cart on startup:', err)
    }
  }

  const cookieStore = useCookieStore()
  cookieStore.loadPreferences()
  if (cookieStore.isAccepted) {
    cookieService.loadScripts(cookieStore.preferences)
  }

  if (toastRef.value) {
    setToastComponent(toastRef.value)
  } else {
    console.error('[ERROR] Toast ref is null - component not properly mounted')
  }
  
  await nextTick()
  if (loadingOverlayRef.value) {
    setLoadingOverlayComponent(loadingOverlayRef.value)
  } else {
    console.error('[ERROR] LoadingOverlay ref is null - component not properly mounted')
  }
})
</script>

<style>
:root {
  --teal: #5C8889;
  --dark: #000;
  --light: #BCE4D8;
  --yellow: #f4d03f;
  --dark-teal: #008C95;
  --bright-teal: #2CBCC4;
  --light-text: #e5e5d8;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  height: 100%;
  -webkit-text-size-adjust: 100%;
  scroll-behavior: smooth;
}

body {
  font-family: 'Montserrat', Arial, sans-serif;
  margin: 0;
  padding: 0;
  min-height: 100%;
  background-color: #ffffff;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow-x: hidden;
}

#app {
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
}

/* Global responsive utilities (no scoped, accessible from any component) */
.desktop-only { display: block; }
.mobile-only { display: none; }

@media (max-width: 1024px) {
  .desktop-only { display: none !important; }
  .mobile-only { display: block !important; }
}

@media (max-width: 1024px) {
  .desktop-only.flex,
  .desktop-only.d-flex,
  .desktop-only.d-inline-flex { display: none !important; }
  .mobile-only.flex,
  .mobile-only.d-flex,
  .mobile-only.d-inline-flex { display: flex !important; }
}

/* Su mobile verticale, niente regole che tagliano il contenuto */
</style>
